<div class="p-3">
    <div class="form-row" *ngIf="enTest && ! (modeRenduService.enModeImpression$ | async)">
        <a class="ml-auto btn btn-danger" (click)="toggleModeRendu()">Changer de mode</a>
    </div>
    <!-- Questionnaire de l’enquête -->
    <bis-questionnaire *ngIf="! (modeRenduService.enModeImpression$ | async)"></bis-questionnaire>
    <!-- Lors du lancement de l’impression, chargement du bon template-->
    <bis-impression-saisie *ngIf="(modeRenduService.enModeImpression$ | async)"></bis-impression-saisie>
</div>

